import PropTypes from 'prop-types';
import React from "react";

import ModalV4 from "../../../app/ui/modal/v4/v4.tsx";

import ButtonDeprecated from "core/gd-components/buttons/gd-button/gd-button.tsx";
import TaskIcon from 'i5-task';

import Classes from "classnames";
import ModalV4Header from "../../../app/ui/modal/v4/header/v4-header";

const propTypes = {
    params: PropTypes.shape({
        onSubmit: PropTypes.func.isRequired,
        companyId: PropTypes.string.isRequired,
        projectId: PropTypes.string.isRequired
    })
};

class ModalEditTaskTypesList extends ModalV4 {

    constructor(props) {
        super(props);
        const { projectId } = props.params;
        const projectTaskTypes = gd.session.projects.get(projectId).getInheritedTaskTypes();

        this.state = {
            selected: projectTaskTypes
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    onTaskTypeClick(ttId) {
        const { selected } = this.state;

        const newSelected = gd.utils.toggleArrayValue(selected.slice(), ttId);

        // dont allow to remove last task type
        if (newSelected.length<1) return false;

        this.setState({
            selected: newSelected
        });
    }

    onSubmit() {
        this.props.params.onSubmit(this.state.selected);
    }

    render() {
        const { companyId } = this.props.params;
        const { selected } = this.state;

        const taskTypes = gd.session.taskTypes.filterByCompany(companyId);

        return (
            <div className="v4-container placement-middle" onClick={this.stopPropagation}>

                <ModalV4Header height={60} title="Task types" onClose={this.closeModal} />

                <div className="main">
                    <div className="tbl task-types">
                        {_.map(taskTypes.models, (tt,key)=>{
                            let isSelected = selected.includes(tt.id);

                            const classes = Classes('task-type-item',{
                                selected: isSelected
                            });

                            const checkboxClasses = Classes('gd-cb i5-checkbox-ok', 'normal-16', {
                                selected: isSelected
                            });

                            return (
                                <div className={classes} key={key} onClick={this.onTaskTypeClick.bind(this, tt.id)}>
                                    <div className="col0">
                                        <div className={checkboxClasses}> </div>
                                    </div>
                                    <div className="col1"><TaskIcon className="task-type-icon" taskType={tt} /></div>
                                    <div className="col2">{tt.name}</div>
                                </div>
                            )
                        })}
                    </div>
                </div>

                <div className="modal-submit">
                    <ButtonDeprecated type="primary" label="Submit" onClick={this.onSubmit.bind(this)} />
                </div>

            </div>
        );
    }
}

ModalEditTaskTypesList.propTypes = propTypes;

module.exports = ModalEditTaskTypesList;






